import React from 'react'
import { useSelector } from 'react-redux'

import AdditionalAttachments from '../../../../../components/NewEncounter/AdditionalAttachmentEncounter/AdditionalAttachments'

export default function PanelPatientDocumentsCard() {
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)

  return (
    <div id={'PanelPatientDocumentsCard'}>
      <AdditionalAttachments
        patientId={patientId}
        showChargeFiles={false}
        showPatientFiles={true}
      />
    </div>
  )
}
